import React, { useState } from 'react';

const FaqAccordion = ({ items }) => {
  const [openIds, setOpenIds] = useState(() => new Set());

  const toggle = (id) =>
    setOpenIds((current) => {
      const next = new Set(current);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });

  const allOpen = openIds.size === items.length;

  return (
    <div className="w-full bg-[#FBFAF9] px-5 py-10 md:px-12 md:py-14">
      <div className="mx-auto w-full max-w-[1200px]">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <h2 className="text-[28px] font-light text-black md:text-[40px]">
            Frequently asked questions.
          </h2>
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={() => setOpenIds(new Set(items.map((item) => item.id)))}
              disabled={allOpen}
              className="rounded-md border border-[#6C2A7A] px-4 py-2 text-sm text-[#6C2A7A] transition-colors hover:bg-[#6C2A7A]/10 disabled:border-black/15 disabled:text-black/30 disabled:hover:bg-transparent"
            >
              Expand all
            </button>
            <button
              type="button"
              onClick={() => setOpenIds(new Set())}
              disabled={openIds.size === 0}
              className="rounded-md border border-[#6C2A7A] px-4 py-2 text-sm text-[#6C2A7A] transition-colors hover:bg-[#6C2A7A]/10 disabled:border-black/15 disabled:text-black/30 disabled:hover:bg-transparent"
            >
              Collapse all
            </button>
          </div>
        </div>

        <ul className="mt-8">
          {items.map((item, index) => {
            const isOpen = openIds.has(item.id);
            return (
              <li key={item.id} className="border-b border-black/10">
                <button
                  type="button"
                  onClick={() => toggle(item.id)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-${item.id}`}
                  className="flex w-full items-center gap-4 py-6 text-left md:gap-10"
                >
                  <span className="w-10 flex-shrink-0 text-sm text-[#A4262C]">
                    {String(index + 1).padStart(2, '0')}/
                  </span>
                  <span className="flex-1 text-[15px] font-semibold text-black md:text-base">
                    {item.question}
                  </span>
                  <span
                    aria-hidden="true"
                    className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md bg-[#6C2A7A] text-xl leading-none text-white"
                  >
                    {isOpen ? '−' : '+'}
                  </span>
                </button>
                {isOpen && (
                  <div id={`faq-${item.id}`} className="pb-8 md:pl-[3.5rem] md:pr-16">
                    {item.answer.map((paragraph, i) => (
                      <p
                        key={i}
                        className="mb-4 text-[15px] leading-relaxed text-black/80 last:mb-0 md:text-base"
                      >
                        {paragraph}
                      </p>
                    ))}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default FaqAccordion;
